/* global gtag */
export function gtagSendEvent(url, eventName = 'alle_tools') {
  const callback = () => {
    if (typeof url === 'string') {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  }

  if (typeof gtag === 'function') {
    gtag('event', eventName, {
      event_callback: callback,
      event_timeout: 2000
    })
  } else {
    callback()
  }

  return false
}
